import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api/apiClient";
import { ModelInfoArraySchema, type ModelInfo } from "@/lib/types/models";

export function useModels(mediaType: "image" | "video") {
  const { data: models = [], isLoading, refetch } = useQuery<ModelInfo[]>({
    queryKey: ["models", mediaType],
    queryFn: async () => {
      const response = await apiGet<unknown[]>("/api/models", { auth: false });
      const validated = ModelInfoArraySchema.parse(response);
      return validated.filter((m) => m.mediaType === mediaType);
    },
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchInterval: 30_000,
  });

  return { models, modelsLoading: isLoading, refetchModels: refetch };
}
